// extracted by mini-css-extract-plugin
export default {"wrapper":"aTO9m5","galleryWrapper":"JK0stz"};